export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5488.bde99b63.jpg";